import React, { useState } from "react";
import { Form, Row, Col, Input, Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

function SearchPopulation(props) {
  const [expand, setExpand] = useState(false);
  const [form] = Form.useForm();

  const getFields = () => {
    const searchFields = [
      {
        name: "player",
        label: "Player Name",
        rules: [
          {
            required: true,
            message: "Player or Card name is required",
          },
        ],
      },
      { name: "year", label: "Year", rules: [] },
      { name: "company", label: "Company name", rules: [] },
      { name: "set_name", label: "Set Name", rules: [] },
      { name: "subset_name", label: "Sub set", rules: [] },
    ];
    const advancedSearchFields = [];

    let fields = searchFields;

    if (expand) {
      fields = [...searchFields, ...advancedSearchFields];
    }

    const children = [];

    fields.forEach((field, idx) => {
      children.push(
        <Col span={8} key={idx}>
          <Form.Item name={field.name} label={field.label} rules={field.rules}>
            <Input placeholder={field.label} />
          </Form.Item>
        </Col>
      );
    });

    return children;
  };

  return (
    <Form
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      onFinish={props.onSearch}
    >
      <Row gutter={24}>{getFields()}</Row>
      <Row>
        <Col
          span={24}
          style={{
            textAlign: "right",
          }}
        >
          <Button type="primary" htmlType="submit" loading={props.loading}>
            Search
          </Button>
          <Button
            style={{
              margin: "0 8px",
            }}
            onClick={() => {
              form.resetFields();
            }}
          >
            Clear
          </Button>
          {/* <a
            style={{
              fontSize: 12,
            }}
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {expand ? <UpOutlined /> : <DownOutlined />} Advanced Search
          </a> */}
        </Col>
      </Row>
    </Form>
  );
}

export default SearchPopulation;
